import * as axios from 'axios'
import produce from 'immer'
import { TEST_ENVIRONMENT } from './environment'

export async function post (values, sourceBusinessUnit) {
    const url = process.env.REACT_APP_API_POST_URL
    const postValues = produce(values => {
      values.requests.forEach(request => {
        if (request.requestingInstitution) {
          request.requestingInstitution = JSON.parse(
            request.requestingInstitution
          )
        } else {
          request.requestingInstitution = null
        }
        request.sourceBusinessUnit = sourceBusinessUnit

        delete request['businessUnit']
        // delete dummy requestedStudyDates field
        delete request['requestedStudyDates']

        if (sourceBusinessUnit === 'Apex Radiology (WA)') {
          delete request.useInteleViewer
        }
      })
    }, values)()
    if (TEST_ENVIRONMENT) {
      console.log(postValues)
    }
    return await axios.post(url, postValues)
}
